module.exports = __webpack_public_path__ + "officialStatic/img/product-shsd.c1c1564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-shsd.png
// module id = fdLW
// module chunks = 0